import i18n from '@plugins/i18n';

import { Collection, User } from '@/models';

export class InvestorUsersReportCollection extends Collection {
    static type = 'InvestorUsersReportCollection';
    static endpoint = User.api.index;
    static model = User;

    get preset_filters() {
        return {
            organisation_type: this.filterOperator('is') + ':INVESTOR'
        };
    }

    get default_headers() {
        return ['id', 'name', 'email', 'organisation_name', 'can_login', 'last_logged_in_at'];
    }

    get xlsx_headers() {
        return ['id', 'name', 'email', 'organisation_name', 'can_login', 'last_logged_in_at'];
    }

    get headers() {
        return [
            this.createHeader('id', i18n.t('id'), {
                classList: ['no-wrap'],
                width: '20rem',
                filterable: {
                    operators: this.getOperators(['eq'])
                }
            }),
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: true
            }),
            this.createHeader('email', i18n.t('email'), {
                width: '15rem',
                filterable: true,
                sortable: true
            }),
            this.createHeader('organisation_name', i18n.tc('investor', 1), {
                path: 'organisation.name',
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: 'organisation'
            }),
            this.createHeader('can_login', i18n.t('login_enabled'), {
                format: 'boolean',
                width: '10rem',
                filterable: true
            }),
            this.createHeader('last_logged_in_at', i18n.t('last_logged_in_at'), {
                format: 'datetime',
                width: '12rem',
                align: 'right',
                filterable: {
                    presetTime: '00:00:00',
                    outputFormat: 'YYYY-MM-DD'
                },
                sortable: true
            })
        ];
    }
}

export default InvestorUsersReportCollection;
